// Bootstrap
require('./bootstrap');

// Cookie
require('./jquery.cookie');

// Slick
require('slick-carousel');
require('slick-lightbox');

/* VueJS */
/* import Vue from 'vue';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip); */

/* FontAwesome */
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

/* New Lazyload  */
import lazySizes from 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// window.lazySizesConfig = window.lazySizesConfig || {};

lazySizes.cfg.expand = 300;

var resizeTimer;
$(window).on('load resize', function () {
    equalHeights();
    setTimeout(equalHeights(), 1000);

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        equalHeights();
    }, 1000);
});

$(document).bind('mouseup touchend', function(e) {
    var container = $("div.sticky-header--desktop-navigation ul.navigation--main");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('div.sticky-header--desktop-navigation ul.navigation--main li.parentnav').removeClass('hover');
    }
});

$(document).bind('mouseup touchend', function(e) {
    var container = $("a.card-image");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('a.card-image').removeClass('hover');
    }
});

$(document).bind('mouseup touchend', function(e) {
    var container = $("#toggleFloating");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('.floating-container').removeClass('active');
        $('.btn-floating').removeClass('active');
    }
});

// $(document).scroll(function() {
//     var scroll = $(window).scrollTop();
//
//     if (scroll > 0) {
//         $("header.sticky-header--desktop").addClass("scrolled");
//     } else {
//         $("header.sticky-header--desktop").removeClass("scrolled");
//     }
// });


$(document).on('scroll', function(e) {
    if ($(window).scrollTop() > 35) {
        $("header.sticky-header--desktop").addClass("scrolled");
    } else {
        $("header.sticky-header--desktop").removeClass("scrolled");
    }
});


$(document).ready(function() {

    $('.loading-page').show();

    $('#accordion .tabClassCollapse').on('shown.bs.collapse', function(e) {
        let $card = $(this).closest('.collapse');
        $('html,body').animate({
            scrollTop: $card.offset().top - 200
        }, 500);
    });

    $(".callback_radio").on('click', function() {
        var $box = $(this);
        if ($box.is(":checked")) {
            var group = ".callback_radio[name='" + $box.attr("name") + "']";
            $(group).prop("checked", false);
            $box.prop("checked", true);
        } else {
            $box.prop("checked", false);
        }
    });

    if ($(window).width() >= 992) {
        $('div.sticky-header--desktop-navigation ul.navigation--main li.parentnav').on("touchstart", function (e) {
            'use strict'; //satisfy code inspectors
            var link = $(this); //preselect the link
            if (link.hasClass('hover')) {
                return true;
            }
            else {
                link.addClass('hover');
                $('div.sticky-header--desktop-navigation ul.navigation--main li.parentnav').not(this).removeClass('hover');
                e.preventDefault();
                return false; //extra, and to make sure the function has consistent return points
            }
        });
    }

    $('a.card-image').on("touchstart", function (e) {
        'use strict'; //satisfy code inspectors
        var link = $(this); //preselect the link
        if (link.hasClass('hover')) {
            return true;
        }
        else {
            link.addClass('hover');
            $('a.card-image').not(this).removeClass('hover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    $('.btn-floating').on('click', function() {
        if($('.floating-container').hasClass('active')) {
            $('.floating-container').removeClass('active');
        } else {
            $('.floating-container').addClass('active');
        }
        if($('.btn-floating').hasClass('active')) {
            $('.btn-floating').removeClass('active');
        } else {
            $('.btn-floating').addClass('active');
        }
    });

    $('.btn-nav').on('click', function(e) {
        e.preventDefault();
        if($('.mobile-nav--container').hasClass('active')) {
            $('.mobile-nav--container').removeClass('active');
            $('.btn-nav').removeClass('active');
            $('body').removeClass('nav-overflow');

        } else {
            $('.mobile-nav--container').addClass('active');
            $('.btn-nav').addClass('active');
            $('body').addClass('nav-overflow');
        }
    });

    /* Transitions Only After Page Load */
    $('body').removeClass('preload');

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });

    $(window).resize(function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    $(window).on('orientationchange', function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    $('#slick_slider').slick({
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: false,
        slidesToShow: 4,

        responsive: [{

            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
      
          }, {
      
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            }

          }, {
      
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            }
      
          }]
    });

    /* Slick Lightbox */
    $('.lightbox').slickLightbox({
        itemSelector: 'a',
        src: 'href',
        caption: 'caption'
    });

    $('.reference-lightbox').slickLightbox({
        itemSelector: 'a.reference-result',
        src: 'href',
        caption: 'caption',
        lazy: true
    });

    $('[data-action=load]').click(function(e) {
        e.preventDefault();
        var el = $(this);
        axios.post(el.data('href'), {})
            .then((response) =>  {
                $(el.data('target')).html(response.data);
            });

    });
});


function checkGrid() { // help function only
    var mode = '';
    if ($(window).width() >= 1200) {
        mode = 'XL';
    }
    else if ($(window).width() >= 992) {
        mode = 'LG';
    }
    else if ($(window).width() >= 768) {
        mode = 'MD';
    }
    else if ($(window).width() >= 576) {
        mode = 'SM';
    }
    else {
        mode = 'XS';
    }
    return mode;
}

function equalHeights() {
    var check = checkGrid();

    if (check !== 'XS') {
        $('.eqh-parent').each(function () {
            var highestBox = 0;
            var highestTitle = 0;
            var highestText = 0;
            var highestBtn = 0;

            $(this).find('.eq-title-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestTitle = $(this).outerHeight();
                }
            });
            $(this).find('.eq-title-height').css({'height': highestTitle + "px"});

            $(this).find('.eq-text-height').each(function () {
                if ($(this).outerHeight() > highestText) {
                    highestText = $(this).outerHeight();
                }
            });
            $(this).find('.eq-text-height').css({'height': highestText + "px"});

            $(this).find('.eq-btn-height').each(function () {
                if ($(this).outerHeight() > highestBtn) {
                    highestBtn = $(this).outerHeight();
                }
            });
            $(this).find('.eq-btn-height').css({'height': highestBtn + "px"});

            $(this).find('.eq-box-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestBox = $(this).outerHeight();
                }
            });
            $(this).find('.eq-box-height').css({'height': highestBox + "px"});
        });
    }
}



// WEBPACK FOOTER //
// ./resources/js/frontend.js